// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".document-preview-image[data-v-7eed5e64]:hover{filter:brightness(.7)}", ""]);
// Exports
module.exports = exports;
